import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';
import CurrentLightTheme from 'foundations-theming/themes/current/light/theme';
import { GlobalStyles } from './GlobalStyles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AppProvider = ({
  // themeName = 'current',
  // themeMode = 'light',
  applyGlobalStyles = false,
  children
}) => {
  // In a follow-up PR, we can add support to load themes dynamically instead.
  // E.g. https://git.hubteam.com/errodriguez/hds-components-prototypes/blob/master/src/theming-experiment/ExperimentalAppProvider.tsx#L37-L46

  return /*#__PURE__*/_jsxs(StyledComponentsThemeProvider, {
    theme: CurrentLightTheme,
    children: [applyGlobalStyles ? /*#__PURE__*/_jsx(GlobalStyles, {}) : null, children]
  });
};